export default __webpack_public_path__ + "static/media/doc-placeholder.6d515408.svg";